import { ScopeSelectKeys } from 'legacy/lut/components/widgets/public/partner360/composedReport'

import { IComposedFilterForSave, ISelectsData } from '../models/state'

export const getFilterForSave = ({
  products,
  partnersInScope,
  scopeValue,
  amplifyMembership,
  geo,
  pbms,
  managers,
  specializations,
  acknowledged,
  fYear,
  partnersType,
  isAcknowledged,
}: ISelectsData): IComposedFilterForSave => {
  return {
    FYear: fYear,
    Pbms: pbms,
    Managers: managers,
    Geo: geo,
    Products: products,
    Acknowledged: acknowledged,
    Specializations: specializations,
    AmplifyMembership: amplifyMembership,
    PartnersType: partnersType,
    IsAcknowledged: isAcknowledged ? 1 : 0,
    Scope:
      scopeValue === ScopeSelectKeys.Manual
        ? { value: scopeValue, partnersInScope: partnersInScope }
        : { value: scopeValue },
  }
}
